/**
 * ORO Trademark Component (#745)
 *
 * Renders brand name with superscript trademark symbol.
 * Usage: <OroTrademark /> renders "ORO move™"
 */

import { BRAND_NAME, BRAND_MARK } from '../constants/brand';

export default function OroTrademark() {
  return (
    <span>
      {BRAND_NAME}
      <sup>{BRAND_MARK}</sup>
    </span>
  );
}
